import {getFirstAttributeValue} from '@aboutyou/backbone/helpers/bapiProduct';
import {BapiProduct} from '@aboutyou/backbone/types/BapiProduct';
import {ProductColor} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_color.types';

export const getTrackingColorFromBapiProduct = (product: BapiProduct) => {
  const firstAttribute = getFirstAttributeValue(product.attributes, 'color');

  return firstAttribute
    ? {id: firstAttribute.id || -1, name: firstAttribute.label}
    : {id: -1, name: ''};
};

export const getTrackingColor = (color: ProductColor | undefined) => {
  const firstAttribute = color;

  return firstAttribute
    ? {id: firstAttribute.id || -1, name: firstAttribute.name}
    : {id: -1, name: ''};
};
